import React, { forwardRef } from 'react';
import classNames from 'classnames';


//container?: boolean | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'fluid';

const Page = forwardRef(({ children, className, container = 'xxl', ...props }, ref) => {
	return (
		<div
			ref={ref}
			className={classNames('page', className, {
				[`container${typeof container === 'string' ? `-${container}` : ''}`]: container,
			})}
			{...props}>
			{children}
		</div>
	);
});

export default Page;
